module.exports = __webpack_public_path__ + "img/lkk.6d80e1ce.svg";